import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from './ThemeProvider';
import { useEffect } from 'react';

export default function ThemeToggleButton() {
  const { theme, setTheme } = useTheme();

  // Sync with device theme on mount
  useEffect(() => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    setTheme(prefersDark ? 'dark' : 'light');
  }, [setTheme]);

  // Handle theme toggle
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setTheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [setTheme]);

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center gap-2 px-4 py-2 rounded-full bg-primary dark:bg-primary-dark text-secondary dark:text-secondary-dark hover:bg-secondary hover:text-primary-text dark:hover:bg-secondary-dark dark:hover:text-primary-text-dark focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 transition-all duration-200"
      aria-label={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {theme === 'dark' ? (
        <>
          <FiSun size={20} />
          <span className="text-sm font-medium">Switch to Light Mode</span>
        </>
      ) : (
        <>
          <FiMoon size={20} />
          <span className="text-sm font-medium">Switch to Dark Mode</span>
        </>
      )}
    </button>
  );
}